import api from "api"

export async function loadHouseholdProperties(store, household_id) {
  const properties = await api.get(`households/${household_id}/properties`)
  await store.update(state => {
    state.householdPropertyIds[household_id] = properties.map(
      property => property.id
    )
    properties.forEach(property => {
      state.properties[property.id] = property
    })
  })
}

export async function loadProperty(store, property_id) {
  const property = await api.get(`properties/${property_id}`)
  await store.update(state => {
    state.properties[property.id] = property
  })
}

export async function addProperty(store, { household_id, ...propertyDetails }) {
  const property = await api.post(
    `households/${household_id}/properties`,
    undefined,
    propertyDetails
  )
  const household = await store.actions.loadHousehold(household_id)
  await store.update(state => {
    state.householdPropertyIds[household_id].push(property.id)
    state.properties[property.id] = property
    delete state.incomeBreakdowns[household_id]
  })

  if (!household.has_confirmed_properties) {
    await store.actions.updateHousehold({
      id: household_id,
      has_confirmed_properties: true
    })
  }

  return {
    propertyId: property.id
  }
}

export async function updateProperty(store, { id, ...propertyDetails }) {
  const property = await api.patch(
    `properties/${id}`,
    undefined,
    propertyDetails
  )

  await store.update(state => {
    state.properties[property.id] = property
    delete state.incomeBreakdowns[property.household_id]
  })
}

export async function deleteProperty(store, { household_id, id }) {
  await api.delete(`properties/${id}`)
  await store.update(state => {
    state.householdPropertyIds[household_id].splice(
      state.householdPropertyIds[household_id].findIndex(
        propertyId => propertyId === id
      ),
      1
    )

    Object.values(state.accounts)
      .filter(({ property_id }) => property_id === id)
      .forEach(({ id }) => {
        state.householdAccountIds[household_id].splice(
          state.householdAccountIds[household_id].findIndex(
            accountId => accountId === id
          ),
          1
        )
        delete state.accounts[id]
      })
    delete state.properties[id]
    delete state.incomeBreakdowns[household_id]
  })
}
